module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "experience"
  }, [_h('video', {
    staticClass: "video",
    attrs: {
      "src": "http://adrienmenegaux.com/video/experience_video.mp4",
      "muted": "",
      "autoplay": ""
    }
  }), " ", _h('audio', {
    attrs: {
      "src": "http://adrienmenegaux.com/sound/castle_in_the_sky_theme_%20joe_hisaishi.mp3",
      "autoplay": "",
      "loop": ""
    }
  }), " ", _h('div', {
    staticClass: "circleContainer",
    style: ({
      opacity: _vm.dragShow ? 1 : 0
    })
  }, [_h('div', {
    staticClass: "landingZone",
    class: {
      grow: _vm.onTarget
    }
  }), " ", _h('svg', {
    staticClass: "rail",
    attrs: {
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "none"
    }
  }, [_h('path', {
    attrs: {
      "d": "m0 0 c 50 0, 100 50, 100 100"
    }
  })]), " ", _h('div', {
    staticClass: "circle",
    class: {
      grabbing: _vm.grabbing
    },
    style: ({
      transform: 'rotate(' + _vm.angle + 'rad)'
    }),
    on: {
      "mousedown": _vm.grab,
      "touchstart": _vm.grab
    }
  })]), " ", _h('Timeline', {
    staticClass: "timeline",
    attrs: {
      "length": _vm.chapters.length,
      "count": _vm.$store.state.chapter,
      "age": _vm.chapters[_vm.$store.state.chapter - 1].title
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-011826d1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Experience.vue
// module id = 49
// module chunks = 1